import { useEffect, useState } from 'react'
import { apiErrorText } from '@/lib/api-error'
import { cardTitle, formCardSm } from '@/lib/form-styles'
import { fetchCalculationEvents } from '../api/calculations.api'
import { datumText } from '../lib/kalkulation-labels'
import type { CalcEvent } from '../types/calculation.types'

/** AP-37 9. — **Verlauf** über alle Fassungen der Nummer (neueste zuerst). */
export function CalculationEventsTab({ kalkulationId, stand }: { kalkulationId: string; stand: string }) {
  const [liste, setListe] = useState<CalcEvent[] | null>(null)
  const [fehler, setFehler] = useState<string | null>(null)

  useEffect(() => {
    fetchCalculationEvents(kalkulationId)
      .then(setListe)
      .catch((e) => setFehler(apiErrorText(e, 'Der Verlauf ließ sich nicht laden.')))
  }, [kalkulationId, stand])

  return (
    <div className={formCardSm}>
      <h3 className={cardTitle}>Verlauf</h3>
      {fehler && <p className="mt-2 text-sm text-destructive">{fehler}</p>}
      {liste?.length === 0 && <p className="mt-2 text-sm text-muted-foreground">Noch nichts geschehen.</p>}
      <ol className="mt-3 space-y-2">
        {(liste ?? []).map((e) => (
          <li key={e.id} className="flex gap-3 text-sm">
            <span className="w-36 shrink-0 tabular-nums text-muted-foreground">{datumText(e.createdAt, true)}</span>
            {e.revision && <span className="w-8 shrink-0 text-xs text-muted-foreground">F{e.revision}</span>}
            <span className="flex-1">{e.text}</span>
            {e.userName && <span className="shrink-0 text-xs text-muted-foreground">{e.userName}</span>}
          </li>
        ))}
      </ol>
    </div>
  )
}
